import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/hero';
import About from '../../components/about/about';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import CtaSection from '../../components/CtaSection/CtaSection';
import ProjectSection3 from '../../components/ProjectSection3/ProjectSection3';
import FunFact from '../../components/FunFact/FunFact';
import Testimonial from '../../components/Testimonial/Testimonial';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/Logo.png'
import WhatsAppCTA from '../../components/whatsapp/whatappcta';
import PopupForm from '../../components/PopupForm/PopupForm';





const HomePage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-1'} Logo={Logo} />
            <Hero />
            <About />
            <ServiceSection />
            <CtaSection />
            <ProjectSection3 /> 
            <FunFact />
            <Testimonial tClass={'wpo-testimonial-section-s2'} />

            <WhatsAppCTA />

            <PopupForm />
            
        
            <Footer />
            <Scrollbar /> 
        </Fragment>
    )
};
export default HomePage;